/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createIndex } from '../../factoriesAny.js';
export var indexDependencies = {
  IndexDependencies: IndexDependencies,
  typedDependencies: typedDependencies,
  createIndex: createIndex
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIndex.generated.js
// module id = 1427
// module chunks = 0